import { FoodsIcon, FoodsIconButton, LinearProgress, Badge } from "@foodpilot/foods";
import { Button, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SsqSsqHeading } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import { HeadingsSectionData } from "../QuestionnairesList";
import { Link } from "react-router";
import { useQuestionnaireListContext } from "../context/useQuestionnaireList";

export const ListView = () => {
    const { ssqSsqHeadings, post, isPostLoading, completeQuestionnaireUrl, canAnswerSsq, canViewSsq, isLocked } =
        useQuestionnaireListContext();

    const { t } = useTranslation();
    const theme = useTheme();

    const headingsData: HeadingsSectionData[] = ssqSsqHeadings.map((ssqSsqHeading: SsqSsqHeading) => {
        return {
            ssqSsqHeading: ssqSsqHeading,
            completion: !isPostLoading ? (post?.completions.headings[ssqSsqHeading.id]?.result ?? null) : undefined,
        };
    });

    return (
        <Stack width={"100%"}>
            {headingsData.map((heading, index) => {
                const isCompleted = heading.completion === 100;
                const goToQuestionnaireText =
                    !canAnswerSsq || isLocked ? t("questionnaire.consult")
                    : isCompleted ? t("questionnaire.modify")
                    : t("questionnaire.complete");

                const url = completeQuestionnaireUrl(heading.ssqSsqHeading);
                return (
                    <Stack
                        key={heading.ssqSsqHeading.id}
                        flexDirection="row"
                        alignItems={"center"}
                        gap={theme.spacing(2)}
                        borderTop={index === 0 ? "none" : `1px solid ${theme.custom.grey[600]}`}
                        paddingBlock={theme.spacing(2)}
                        // Overriding only if first index
                        paddingTop={index === 0 ? 0 : undefined}
                    >
                        <Stack
                            justifyItems={"space-between"}
                            alignItems={"space-between"}
                            justifyContent={"space-between"}
                            flexDirection={"row"}
                            gap={theme.spacing(2)}
                            flex={1}
                            flexWrap={"wrap"}
                        >
                            <Stack flexDirection={"row"} gap={"12px"} alignItems={"center"} minWidth={"250px"} flex={1}>
                                <Badge>{index + 1}</Badge>

                                <Stack gap="4px">
                                    <Typography variant="h5">{heading.ssqSsqHeading.ssqHeading.title}</Typography>
                                </Stack>
                            </Stack>

                            <Stack width={{ xs: "200px", sm: "250px" }} justifyContent={"center"}>
                                {heading.completion === undefined ?
                                    <CircularProgress size="18px" />
                                :   <LinearProgress value={heading.completion ?? 0} />}
                            </Stack>
                        </Stack>
                        {canViewSsq && (
                            <Stack flexDirection="row" alignItems={"center"} gap={theme.spacing(2)} width="135px">
                                <Link
                                    to={url}
                                    style={{
                                        color: theme.custom.grey[2800],
                                        width: "100%",
                                    }}
                                >
                                    <Button
                                        variant="secondary"
                                        endIcon={
                                            <FoodsIcon icon="arrowRight" size={2} color={theme.custom.grey[2800]} />
                                        }
                                        sx={{
                                            display: { xs: "none", sm: "inline-flex" },
                                            width: "100%",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Typography variant="small-bold">{goToQuestionnaireText}</Typography>
                                    </Button>
                                    <FoodsIconButton
                                        size={"s"}
                                        icon={"arrowRight"}
                                        withBackground
                                        tooltip={{
                                            text: goToQuestionnaireText,
                                        }}
                                        buttonProps={{
                                            sx: {
                                                display: { xs: "inline-flex", sm: "none" },
                                            },
                                        }}
                                    />
                                </Link>
                            </Stack>
                        )}
                    </Stack>
                );
            })}
        </Stack>
    );
};
